













import ResourceItemCard from "./ResourceItemCard.vue";
import { ResourceItem } from "@megarax/client/src/resources/ResourceItem";
import { useActions } from "@/shared/useMegaraxClient";
import { createComponent, Ref, ref, SetupContext } from "@vue/composition-api";
import { Resource } from "@megarax/client/src";
import SpinnerCard from "@/components/SpinnerCard.vue";
import { FullResourceActions } from "@megarax/client/src/actions";
import { ResourceAppModule } from "../../shared/app";
import { useAsyncRef } from "@/shared/useAsyncRef";
import { useResourceProvider } from "../../shared/useResourceProvider";
import { meResource } from "@megarax/iam/restApi";

interface Props {
  module: ResourceAppModule<FullResourceActions<any, any>>;
}

export function resourceItemManager<T extends ResourceItem>(
  resource: Resource<FullResourceActions<any, any>>,
  ctx: SetupContext,
) {
  const item: Ref<T | null> = ref(null);
  const actions = useActions(resource);
  const meResourceProvider = useResourceProvider(meResource);

  const canEdit = useAsyncRef(() =>
    meResourceProvider.isAllowed({
      action: [actions.appName, actions.service, "update"].join("."),
    }),
  );

  async function fetchItem(id: number | string) {
    item.value = await actions.fetchItem(id);
  }

  async function save(newItem: T) {
    const updatedItem = await actions.updateItem(newItem);
    ctx.root.$notify.success(`Zapisano zmiany.`);
    item.value = updatedItem;
  }

  async function deleteItem() {
    await actions.deleteItem(item.value!.id!);
    ctx.root.$notify.success(`Usunięto rekord.`);
    ctx.root.$router.go(-1);
  }

  return { item, fetchItem, save, deleteItem, canEdit };
}

export default createComponent<Props>({
  name: "ResourceItemView",
  components: { ResourceItemCard, SpinnerCard },
  beforeRouteLeave(to: any, from: any, next: any) {
    if ((this as any).editing) {
      if (!window.confirm("Wyjść bez zapisywania?")) {
        return;
      }
    }
    next();
  },
  props: {
    module: {
      required: true,
    },
  },
  setup(props, ctx) {
    const editing = ref(false);

    const { item, fetchItem, save, deleteItem, canEdit } = resourceItemManager(
      props.module.resource,
      ctx,
    );

    function saveEdit(item: ResourceItem) {
      save(item).then(() => {
        editing.value = false;
      });
    }

    fetchItem(ctx.root.$route.params.id);
    return { item, saveEdit, deleteItem, editing, canEdit };
  },
});
